import type { Deal, MainTab } from '@/types'
import { dealMatchesMainTab, dealMatchesSearch } from './deals-constants'

export type DealsFilterParams = {
  mainTab: MainTab
  closerFilter: string
  searchTerm: string
  showStagnantOnly: boolean
  etapaFilter: string
  periodFilter: string
  userRole?: string
  userId?: string
}

function matchesPeriod(deal: Deal, periodFilter: string): boolean {
  if (periodFilter === 'all') return true

  const dealDate = new Date(deal.createdAt)
  if (Number.isNaN(dealDate.getTime())) return false

  const now = new Date()
  let startDate: Date

  switch (periodFilter) {
    case 'month':
      startDate = new Date(now.getFullYear(), now.getMonth(), 1)
      break
    case 'quarter': {
      const quarter = Math.floor(now.getMonth() / 3)
      startDate = new Date(now.getFullYear(), quarter * 3, 1)
      break
    }
    case 'year':
      startDate = new Date(now.getFullYear(), 0, 1)
      break
    default:
      return true
  }

  return dealDate >= startDate
}

function matchesCloser(
  deal: Deal,
  closerFilter: string,
  userRole?: string,
  userId?: string,
): boolean {
  const role = userRole?.toUpperCase()
  if (role === 'ADMIN') {
    return closerFilter === 'all' || deal.closerId === closerFilter
  }

  return deal.closerId === userId
}

/** Filtro único da listagem Deals — usado pela página e pelo store. */
export function filterVisibleDeals(deals: Deal[], params: DealsFilterParams): Deal[] {
  const {
    mainTab,
    closerFilter,
    searchTerm,
    showStagnantOnly,
    etapaFilter,
    periodFilter,
    userRole,
    userId,
  } = params

  return deals.filter((d) => {
    if (!matchesCloser(d, closerFilter, userRole, userId)) return false
    if (!dealMatchesMainTab(d, mainTab)) return false
    if (showStagnantOnly && !d.stagnant) return false
    if (!dealMatchesSearch(d, searchTerm)) return false
    if (etapaFilter !== 'all' && d.etapa !== etapaFilter) return false
    if (!matchesPeriod(d, periodFilter)) return false
    return true
  })
}
